export const base_URL = "https://upwardiqsuite.com/api/"; 
//export const base_URL = "http://localhost:8081/api/";
//export const base_URL = "https://sit.upwardiqsuite.com/api/";

export const loginApi = async (obj) => {
  let res = await fetch(base_URL+"login", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE"
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

export const changePassword = async (obj) => {
  // let accessToken = await getAccessToken()
  let res = await fetch(base_URL+"changePassword", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      // "x-access-token": accessToken
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

export const forgotPassword = async (obj) => {
  let res = await fetch(base_URL+"forgotPassword", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
// Account Activation and deactivation
export const changeAccountStatus = async (payload) => {
  try {
    // Get access token from localStorage if available
    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    const headers = {
      "Content-Type": "application/json",
    };
    
    // Add authorization header if token exists
    if (accessToken) {
      headers["x-access-token"] = accessToken;
    }
    
    console.log("Making API call to:", `${base_URL}updateUserStatus`);
    console.log("Payload:", payload);
    console.log("Headers:", headers);
    
    const response = await fetch(`${base_URL}updateUserStatus`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });
    
    console.log("Response status:", response.status);
    console.log("Response ok:", response.ok);
    
    if (!response.ok) {
      const errorData = await response.json();
      console.log("Error response body:", errorData);
      errorData.status = 'E';
      errorData.apiStatus = response.status;
      return errorData;
    }
    
    const responseData = await response.json();
    console.log("Success response body:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error in updateUserStatus:", error);
    throw error;
  }
}
// users
export const createUser = async (data) => {
  try {
    const response = await fetch(`${base_URL}createUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error in createUser:", error);
    throw error;
  }
};

export const getAllUsers = async () => {
  try {
    // Get access token from localStorage if available
    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    const headers = {
      "Content-Type": "application/json",
    };
    
    // Add authorization header if token exists
    if (accessToken) {
      headers["x-access-token"] = accessToken;
    }
    
    const response = await fetch(`${base_URL}getAllUsers`, {
      method: "GET",
      headers,
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      errorData.apiStatus = response.status;
      return errorData;
    }
    
    return response.json();
  } catch (error) {
    console.error("Error in getAllUsers:", error);
    throw error;
  }
};

export const getUserInfo = async (userId) => {
  try {
    const response = await fetch(`${base_URL}getUserInfo/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getUserInfo:", error);
    throw error;
  }
};

export const updateUser = async (userId, data) => {
  try {
    const response = await fetch(`${base_URL}updateUser/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error in updateUser:", error);
    throw error;
  }
}

export const deleteUser = async (userId) => {
  try {
    const response = await fetch(`${base_URL}deleteUser/${userId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in deleteUser:", error);
    throw error;
  }
};

export const getUsersByRoleId = async (roleId) => {
  try {
    const response = await fetch(`${base_URL}getUsersByRoleId/${roleId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getUsersByRole:", error);
    throw error;
  }
};
export const getRecruitersByManager = async (userId) => {
  try {
    const response = await fetch(`${base_URL}getRecruitersByManager/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getUsersByRole:", error);
    throw error;
  }
};

// Requisition
export const createRequisition = async (data) => {
  try {
    const response = await fetch(`${base_URL}createRequisition`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error in createRequisition:", error);
    throw error;
  }
};

export const getAllRequisitions = async () => {
  try {
    const response = await fetch(`${base_URL}getAllRequisitions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getAllRequisitions:", error);
    throw error;
  }
};

export const getAssignedJobsForRecruiter = async (recruiterId) => {
  try {
    const response = await fetch(`${base_URL}getAssignedJobsForRecruiter/${recruiterId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getAssignedJobsForRecruiter:", error);
    throw error;
  }
};

export const getRequisition = async (requisitionId) => {
  try {
    const response = await fetch(`${base_URL}getRequisition/${requisitionId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getRequisition:", error);
    throw error;
  }
};

export const updateRequisition = async (requisitionId, data) => {
  try {
    const response = await fetch(`${base_URL}updateRequisition/${requisitionId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error in updateRequisition:", error);
    throw error;
  }
};

export const deleteRequisition = async (requisitionId) => {
  try {
    const response = await fetch(`${base_URL}deleteRequisition/${requisitionId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in deleteRequisition:", error);
    throw error;
  }
};

// Candidates
export const createCandidate = async (data) => {
  try {
    let options = {
      method: "POST",
    };
    if (data instanceof FormData) {
      // Do not set Content-Type header for FormData; browser will set it
      options.body = data;
    } else {
      options.headers = { "Content-Type": "application/json" };
      options.body = JSON.stringify(data);
    }
    const response = await fetch(`${base_URL}createCandidate`, options);
    return response.json();
  } catch (error) {
    console.error("Error in createCandidate:", error);
    throw error;
  }
};

export const getAllCandidates = async () => {
  try {
    const response = await fetch(`${base_URL}getAllCandidates`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getAllCandidates:", error);
    throw error;
  }
};

export const getCandidateInfo = async (candidateId) => {
  try {
    console.log("Calling getCandidateInfo with ID:", candidateId); // Debug log
    const response = await fetch(`${base_URL}getCandidateInfo/${candidateId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    console.log("Response status:", response.status); // Debug log
    
    if (!response.ok) {
      const errorData = await response.json();
      console.log("Error response:", errorData); // Debug log
      errorData.status = 'E';
      errorData.apiStatus = response.status;
      return errorData;
    }
    
    const data = await response.json();
    console.log("Success response:", data); // Debug log
    return data;
  } catch (error) {
    console.error("Error in getCandidateInfo:", error);
    throw error;
  }
};

export const updateCandidate = async (candidateId, data) => {
  try {
    let options = {
      method: "PUT",
    };
    if (data instanceof FormData) {
      // Do not set Content-Type header for FormData; browser will set it
      options.body = data;
    } else {
      options.headers = { "Content-Type": "application/json" };
      options.body = JSON.stringify(data);
    }
    const response = await fetch(`${base_URL}updateCandidate/${candidateId}`, options);
    return response.json();
  } catch (error) {
    console.error("Error in updateCandidate:", error);
    throw error;
  }
};

export const deleteCandidate = async (candidateId) => {
  try {
    const response = await fetch(`${base_URL}deleteCandidate/${candidateId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in deleteCandidate:", error);
    throw error;
  }
};

export const getCandidatesBySkillsAndJob = async (skills, jobId) => {
  try {
    const url = `${base_URL}getCandidatesBySkillsAndJob?skills=${encodeURIComponent(skills)}&job_id=${encodeURIComponent(jobId)}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      return errorData;
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getCandidatesBySkillsAndJob:", error);
    throw error;
  }
};

// Locations
export const createLocation = async (obj) => {
  let res = await fetch(base_URL+"createLocation", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getLocation = async (id) => {
  let res = await fetch(base_URL+"getLocation/"+id, {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getAllLocations = async () => {
  let res = await fetch(base_URL+"getAllLocations", {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const updateLocation = async (obj, id) => {
  let res = await fetch(`${base_URL}updateLocation/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
     
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const deleteLocation = async (id) => {
  let res = await fetch(base_URL+"deleteLocation/"+id, {
    method: "DELETE",
    headers: {
      // "x-access-token": accessToken
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

// Skill
export const createSkill = async (obj) => {
  let res = await fetch(base_URL+"createSkill", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getSkill = async (id) => {
  let res = await fetch(base_URL+"getSkill/"+id, {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getAllSkills = async () => {
  let res = await fetch(base_URL+"getAllSkills", {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const updateSkill = async (obj, id) => {
  let res = await fetch(`${base_URL}updateSkill/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const deleteSkill = async (id) => {
  let res = await fetch(base_URL+"deleteSkill/"+id, {
    method: "DELETE",
    headers: {
      // "x-access-token": accessToken
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

// Education Qualification
export const createEducationQualification = async (obj) => {
  let res = await fetch(
    base_URL + "createEducationQualification",
    { 
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    }
  );

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    return data;
  }

  let data = await res.json();
  return data;
};

export const getEducationQualification = async (id) => {
  let res = await fetch(
    base_URL + "getEducationQualification/" + id,
    {
      headers: {},
    }
  );

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    return data;
  }

  let data = await res.json();
  return data;
};

export const getAllEducationQualifications = async () => {
  let res = await fetch(
    base_URL + "getAllEducationQualifications",
    {
      headers: {},
    }
  );

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    return data;
  }

  let data = await res.json();
  return data;
};

export const updateEducationQualification = async (obj, id) => {
  let res = await fetch(
    `${base_URL}updateEducationQualification/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    }
  );

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    return data;
  }

  let data = await res.json();
  return data;
};

export const deleteEducationQualification = async (id) => {
  let res = await fetch(
    base_URL + "deleteEducationQualification/" + id,
    {
      method: "DELETE",
      headers: {},
    }
  );

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    return data;
  }

  let data = await res.json();
  return data;
};

// Tag
export const createTag = async (obj) => {
  let res = await fetch(base_URL+"createTag", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getTag = async (id) => {
  let res = await fetch(base_URL+"getTag/"+id, {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getAllTags = async () => {
  let res = await fetch(base_URL+"getAllTags", {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const updateTag = async (obj, id) => {
  let res = await fetch(`${base_URL}updateTag/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
     
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const deleteTag = async (id) => {
  let res = await fetch(base_URL+"deleteTag/"+id, {
    method: "DELETE",
    headers: {
      // "x-access-token": accessToken
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

// Status
export const createStatus = async (obj) => {
  let res = await fetch(base_URL+"createStatus", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getStatus = async (id) => {
  let res = await fetch(base_URL+"getStatus/"+id, {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getAllStatuses = async () => {
  let res = await fetch(base_URL+"getAllStatuses", {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const updateStatus = async (obj, id) => {
  let res = await fetch(`${base_URL}updateStatus/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
     
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const deleteStatus = async (id) => {
  let res = await fetch(base_URL+"deleteStatus/"+id, {
    method: "DELETE",
    headers: {
      // "x-access-token": accessToken
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

// Job Type
export const createJobType = async (obj) => {
  let res = await fetch(base_URL+"createJobType", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getJobType = async (id) => {
  let res = await fetch(base_URL+"getJobType/"+id, {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getAllJobTypes = async () => {
  let res = await fetch(base_URL+"getAllJobTypes", {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const updateJobType = async (obj, id) => {
  let res = await fetch(`${base_URL}updateJobType/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
     
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const deleteJobType = async (id) => {
  let res = await fetch(base_URL+"deleteJobType/"+id, {
    method: "DELETE",
    headers: {
      // "x-access-token": accessToken
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

// Department
export const createDepartment = async (obj) => {
  let res = await fetch(base_URL+"createDepartment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getDepartment = async (id) => {
  let res = await fetch(base_URL+"getDepartment/"+id, {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const getAllDepartments = async () => {
  let res = await fetch(base_URL+"getAllDepartments", {
    headers: {
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const updateDepartment = async (obj, id) => {
  let res = await fetch(`${base_URL}updateDepartment/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
     
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}
export const deleteDepartment = async (id) => {
  let res = await fetch(base_URL+"deleteDepartment/"+id, {
    method: "DELETE",
    headers: {
      // "x-access-token": accessToken
    }
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}



// Assign Job
export const assignCandidates = async (obj) => {
  try {
    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    const headers = { "Content-Type": "application/json" };
    if (accessToken) headers["x-access-token"] = accessToken;

    console.log("assignCandidates request:", obj);
    const res = await fetch(base_URL+"assignCandidates", {
      method: "POST",
      headers,
      body: JSON.stringify(obj)
    });

    if (!res.ok) {
      const data = await res.json();
      data.status = 'F';
      data.apiStatus = res.status;
      console.log(data);
      return data;
    }
    const data = await res.json();
    console.log("assignCandidates response:", data);
    return data;
  } catch (error) {
    console.error('Error in assignCandidates:', error);
    throw error;
  }
}

// Assign Recruiter to Requisition
export const assignRecruiters = async (obj) => {
  let res = await fetch(base_URL+"assignRecruiters", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
}

// Un Assign Candidate
export const unassignCandidate = async (obj) => {
  let res = await fetch(base_URL+"unassignCandidate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj)
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = 'F';
    data.apiStatus = res.status;
    console.log(data)
    return data;
  }
  let data = await res.json();
  return data;
};

// Get jobs for a specific candidate
export const getJobsForCandidate = async (candidateId) => {
  try {
    const response = await fetch(`${base_URL}getJobsForCandidate/${candidateId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getJobsForCandidate:", error);
    throw error;
  }
};

// Get candidates for a specific job
export const getCandidatesForAssignment = async (payload) => {
  try {
    if (!payload?.requisition_id) {
      console.error("getCandidatesForAssignment - Invalid payload:", payload);
      return {
        result_code: 400,
        status: 'E',
        message: 'requisition_id is required',
      };
    }

    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    const headers = {
      "Content-Type": "application/json",
    };
    if (accessToken) headers["x-access-token"] = accessToken;

    console.log("Calling getCandidatesForAssignment with payload:", payload);

    const response = await fetch(`${base_URL}getCandidatesForAssignment`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const err = await response.json();
      console.error("getCandidatesForAssignment API error:", response.status, err);
      return err;
    }

    const data = await response.json();
    console.log("getCandidatesForAssignment response:", data);
    return data;
  } catch (error) {
    console.error("Error in getCandidatesForAssignment:", error);
    throw error;
  }
};
export const getCandidatesByRequisition = async (payload) => {
  try {
    // Ensure requisition_id is valid
    if (!payload?.requisition_id) {
      console.error("getCandidatesByRequisition - Invalid payload:", payload);
      return {
        result_code: 400,
        status: 'E',
        message: 'requisition_id is required',
        result_info: []
      };
    }

    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    const headers = {
      "Content-Type": "application/json",
    };
    
    if (accessToken) {
      headers["x-access-token"] = accessToken;
    }

    console.log("Calling getCandidatesByRequisition with payload:", payload);

    const response = await fetch(`${base_URL}getCandidatesByRequisition`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      console.error("API Error - Status:", response.status);
      const errorData = await response.json();
      console.error("API Error Data:", errorData);
      return errorData;
    }
    
    const data = await response.json();
    console.log("getCandidatesByRequisition response:", data);
    return data;
  } catch (error) {
    console.error("Error in getCandidatesByRequisition:", error);
    throw error;
  }
};


// Get candidates for a specific job
export const getCandidatesForJob = async (jobId) => {
  try {
    const response = await fetch(`${base_URL}getCandidatesForJob/${jobId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getCandidatesForJob:", error);
    throw error;
  }
};
    
// Update candidate status for a job
export const updateCandidateStatus = async (payload) => {
  try {
    const response = await fetch(`${base_URL}updateCandidateStatus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return response.json();
  } catch (error) {
    console.error("Error in updateCandidateStatus:", error);
    throw error;
  }
};

// Get Admin Dashboard Data
export const getAdminDashboard = async () => {
  try {
    const response = await fetch(`${base_URL}getAdminDashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getAdminDashboard:", error);
    throw error;
  }
};

// Get Hiring Manager Dashboard Data
export const getHiringManagerDashboard = async () => {
  try {
    const response = await fetch(`${base_URL}getHiringManagerDashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getHiringManagerDashboard:", error);
    throw error;
  }
};

// Clients
export const createClient = async (data) => {
  try {
    const response = await fetch(`${base_URL}createClient`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error in createUser:", error);
    throw error;
  }
};

export const getAllClients = async () => {
  try {
    // Get access token from localStorage if available
    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    const headers = {
      "Content-Type": "application/json",
    };
    
    // Add authorization header if token exists
    if (accessToken) {
      headers["x-access-token"] = accessToken;
    }
    
    const response = await fetch(`${base_URL}getAllClients`, {
      method: "GET",
      headers,
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      errorData.apiStatus = response.status;
      return errorData;
    }
    
    return response.json();
  } catch (error) {
    console.error("Error in getAllClients:", error);
    throw error;
  }
};

export const getActiveClients = async () => {
  try {
    // Get access token from localStorage if available
    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    const headers = {
      "Content-Type": "application/json",
    };
    
    // Add authorization header if token exists
    if (accessToken) {
      headers["x-access-token"] = accessToken;
    }
    
    const response = await fetch(`${base_URL}getActiveClients`, {
      method: "GET",
      headers,
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      errorData.apiStatus = response.status;
      return errorData;
    }
    
    return response.json();
  } catch (error) {
    console.error("Error in getActiveClients:", error);
    throw error;
  }
};

export const getClientInfo = async (clientId) => {
  try {
    const response = await fetch(`${base_URL}getClientInfo/${clientId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getUserInfo:", error);
    throw error;
  }
};

export const updateClient = async (clientId, data) => {
  try {
    const response = await fetch(`${base_URL}updateClient/${clientId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error in updateUser:", error);
    throw error;
  }
}

export const deleteClient = async (clientId) => {
  try {
    const response = await fetch(`${base_URL}deleteClient/${clientId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in deleteUser:", error);
    throw error;
  }
};

export const getClientReport = async (clientId, startDate, endDate) => {
  try {
    const response = await fetch(`${base_URL}getClientReport?client_id=${clientId}&start_date=${startDate}&end_date=${endDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getClientReport:", error);
    throw error;
  }
};
export const getDailyReport = async (clientId, recruiterId, start_date, end_date) => {
  try {
    const response = await fetch(`${base_URL}getDailyReport?client_id=${clientId}&recruiter_id=${recruiterId}&start_date=${start_date}&end_date=${end_date}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getClientReport:", error);
    throw error;
  }
};
export const getRecruiterReport = async (recruiterId, startDate, endDate) => {
  try {
    const response = await fetch(`${base_URL}getRecruiterReport?recruiter_id=${recruiterId}&start_date=${startDate}&end_date=${endDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getRecruiterReport:", error);
    throw error;
  }
};
export const getFinalSummary = async (clientId, startDate, endDate) => {
  try {
    const response = await fetch(`${base_URL}getFinalSummary?client_id=${clientId}&start_date=${startDate}&end_date=${endDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getFinalSummary:", error);
    throw error;
  }
};
// User By Report
export const getUserByReport = async (recruiterId, startDate, endDate) => {
  try {
    const response = await fetch(`${base_URL}getUserByReport?recruiter_id=${recruiterId}&start_date=${startDate}&end_date=${endDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getUserByReport:", error);
    throw error;
  }
};
// Status By Report
export const getStatusByReport = async (clientId, recruiterId, startDate, endDate) => {
  try {
    const response = await fetch(`${base_URL}getStatusByReport?client_id=${clientId}&recruiter_id=${recruiterId}&start_date=${startDate}&end_date=${endDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  } catch (error) {
    console.error("Error in getStatusByReport:", error);
    throw error;
  }
};

export const getAllRecruiters = async () => {
  try {
    // Get access token from localStorage if available
    const accessToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    const headers = {
      "Content-Type": "application/json",
    };
    
    // Add authorization header if token exists
    if (accessToken) {
      headers["x-access-token"] = accessToken;
    }
    
    const response = await fetch(`${base_URL}getAllRecruiters`, {
      method: "GET",
      headers,
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      errorData.apiStatus = response.status;
      return errorData;
    }
    
    return response.json();
  } catch (error) {
    console.error("Error in getAllUsers:", error);
    throw error;
  }
};
export const getCandidateComments = async (payload) => {
  try {
    const res = await fetch(base_URL + "getCandidateComments", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    return res.json();
  } catch (error) {
    console.error("Error in getCandidateComments:", error);
    throw error;
  }
};
export const updateRequisitionStatus = async (id, payload) => {
  try {
    const response = await fetch(
      `${base_URL}updateRequisitionStatus/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    return response.json();
  } catch (error) {
    console.error("Error updating requisition status:", error);
    throw error;
  }
};

// Get recruiter mappings and targets for a requisition
export const getRecruiterMappings = async (requisitionId) => {
  try {
    const response = await fetch(
      `${base_URL}getRecruiterMappings/${requisitionId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.json();
  } catch (error) {
    console.error("Error fetching recruiter mappings:", error);
    throw error;
  }
};

// Get candidates matching all provided skills
export const getCandidatesBySkills = async (skills) => {
  try {
    const response = await fetch(`${base_URL}getCandidatesBySkills`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ skills }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      return errorData;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error in getCandidatesBySkills:', error);
    throw error;
  }
};

export const reconcileAllocations = async (data) => {
  try {
    const response = await fetch(`${base_URL}updateRecruiterAllocations`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error('Error in reconcileAllocations:', error);
    throw error;
  }
};

export const getRecruiterAllocationDetails = async (requisitionId) => {
  try {
    const response = await fetch(
      `${base_URL}getRecruiterAllocationDetails/${requisitionId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      return errorData;
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching recruiter allocation details:', error);
    throw error;
  }
};


export const updateRequisitionComprehensive = async (payload) => {
  try {
    const response = await fetch(`${base_URL}updateRequisition`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      return errorData;
    }
    return response.json();
  } catch (error) {
    console.error('Error updating requisition:', error);
    throw error;
  }
};
export const updateRecruiterAllocationsNew = async (payload) => {
  try {
    const response = await fetch(`${base_URL}updateRecruiterAllocations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      return errorData;
    }
    return response.json();
  } catch (error) {
    console.error('Error updating recruiter allocations:', error);
    throw error;
  }
};
export const getSixthsenseRawCandidateDetails = async ()=>{
  try{
    const response = await fetch(`${base_URL}getSixthsenseRawCandidateDetails`, {

     method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      errorData.status = 'E';
      return errorData;
    }
    return response.json();
  } catch (error) {
    console.error('Error while fetching the candidates:', error);
    throw error;
  }
};

// export const getSixthsenseCandidateInfo = async (CandidateID)=>{
//   try{
//      const response = await fetch(`${base_URL}getSixthsenseCandidateInfo${CandidateID}`, {

//      method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });
//     if (!response.ok) {
//       const errorData = await response.json();
//       errorData.status = 'E';
//       return errorData;
//     }
//     return response.json();
//   } catch (error) {
//     console.error('Error while fetching the candidate:', error);
//     throw error;
//   }
// };